(() => {
  const DESKTOP_HOVER = '(min-width: 990px) and (hover: hover)';
  const TOUCH_LAYOUT = '(max-width: 989px), (hover: none)';
  const GOLD = '#d9b45b';

  const account = document.querySelector('shopify-account.header__icon--account');
  const cartLink = document.getElementById('cart-icon-bubble');
  const cartElement = document.querySelector('cart-notification');
  const cartPanel = document.getElementById('cart-notification');
  const cartProduct = document.getElementById('cart-notification-product');

  if (!account && !cartLink) return;

  let accountCloseTimer;
  let cartCloseTimer;
  let cartRequest = 0;

  const getAccountParts = () => {
    const root = account?.shadowRoot;
    return {
      button: root?.querySelector('.account-button'),
      close: root?.querySelector('#close-button'),
      dialog: root?.querySelector('dialog'),
      root,
    };
  };

  const closeAccount = (force = false) => {
    window.clearTimeout(accountCloseTimer);
    const { close, dialog, root } = getAccountParts();
    if (!dialog?.open) return;
    if (!force && root?.activeElement && root.activeElement !== document.body) return;
    close?.click();
  };

  const openAccount = () => {
    const { button, dialog } = getAccountParts();
    if (!button || dialog?.open) return;
    closeCartPreview();
    button.click();
  };

  const scheduleAccountClose = () => {
    window.clearTimeout(accountCloseTimer);
    accountCloseTimer = window.setTimeout(() => {
      if (!account?.matches(':hover')) closeAccount();
    }, 220);
  };

  if (account) {
    account.style.setProperty('--shopify-account-color-accent', GOLD);
    const translateAccountOrderLink = () =>
      account.shadowRoot?.querySelector('a[href*="/orders"]')?.replaceChildren('Commande');
    const scheduleAccountTranslation = () => {
      [0, 100, 300, 700].forEach((delay) => window.setTimeout(translateAccountOrderLink, delay));
    };
    scheduleAccountTranslation();
    account.addEventListener('open', scheduleAccountTranslation);
    account.addEventListener('click', scheduleAccountTranslation);

    account.addEventListener('pointerenter', () => {
      if (window.matchMedia(DESKTOP_HOVER).matches) {
        window.clearTimeout(accountCloseTimer);
        openAccount();
      }
    });

    account.addEventListener('pointerleave', () => {
      if (window.matchMedia(DESKTOP_HOVER).matches) scheduleAccountClose();
    });

    account.addEventListener('focusin', () => {
      if (window.matchMedia(DESKTOP_HOVER).matches) openAccount();
    });
  }

  if (!cartLink || !cartElement || !cartPanel || !cartProduct) return;

  const nativeAriaLabel = cartPanel.getAttribute('aria-label') || '';
  const nativeRenderContents =
    typeof cartElement.renderContents === 'function' ? cartElement.renderContents.bind(cartElement) : null;

  const previewHeading = document.createElement('h2');
  previewHeading.className = 'mediazone-cart-preview__heading';
  previewHeading.textContent = 'Panier';
  cartPanel.querySelector('.cart-notification__header')?.prepend(previewHeading);

  const formatMoney = (amount, currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency: currency || 'EUR',
      }).format((Number(amount) || 0) / 100);
    } catch (error) {
      return `${((Number(amount) || 0) / 100).toFixed(2)} \u20ac`;
    }
  };

  const imageUrl = (item) => {
    const source = item.featured_image?.url || item.image || '';
    return source.startsWith('//') ? `https:${source}` : source;
  };

  const renderCart = (cart) => {
    cartProduct.replaceChildren();

    if (!cart?.items?.length) {
      const empty = document.createElement('p');
      empty.className = 'mediazone-cart-preview__empty';
      empty.textContent = 'Votre panier est vide.';
      cartProduct.append(empty);
      return;
    }

    const list = document.createElement('ul');
    list.className = 'mediazone-cart-preview__items';

    cart.items.slice(0, 3).forEach((item) => {
      const row = document.createElement('li');
      row.className = 'mediazone-cart-preview__item';

      const source = imageUrl(item);
      if (source) {
        const image = document.createElement('img');
        image.className = 'mediazone-cart-preview__image';
        image.src = source;
        image.alt = '';
        image.width = 56;
        image.height = 56;
        image.loading = 'lazy';
        row.append(image);
      } else {
        row.classList.add('mediazone-cart-preview__item--no-image');
      }

      const details = document.createElement('div');
      const title = document.createElement('a');
      title.className = 'mediazone-cart-preview__title';
      title.href = item.url || cartLink.href;
      title.textContent = item.product_title || item.title || 'Article';

      const meta = document.createElement('p');
      meta.className = 'mediazone-cart-preview__meta';
      meta.textContent = `${item.quantity} \u00d7 ${formatMoney(item.final_price, cart.currency)}`;

      details.append(title, meta);
      row.append(details);
      list.append(row);
    });

    cartProduct.append(list);

    if (cart.items.length > 3) {
      const more = document.createElement('p');
      more.className = 'mediazone-cart-preview__more';
      more.textContent = `Et ${cart.items.length - 3} autre${cart.items.length - 3 > 1 ? 's' : ''} article${
        cart.items.length - 3 > 1 ? 's' : ''
      }`;
      cartProduct.append(more);
    }
  };

  const setPreviewVisible = (visible) => {
    cartPanel.classList.toggle('mediazone-cart-preview', visible);
    cartPanel.classList.toggle('animate', visible);
    cartPanel.classList.toggle('active', visible);
    cartPanel.setAttribute('aria-modal', visible ? 'false' : 'true');
    cartPanel.setAttribute('aria-label', visible ? 'Aper\u00e7u du panier' : nativeAriaLabel);
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.setAttribute('aria-expanded', String(visible));
  };

  function closeCartPreview({ restoreFocus = false } = {}) {
    window.clearTimeout(cartCloseTimer);
    if (!cartPanel.classList.contains('mediazone-cart-preview')) return;
    cartRequest += 1;
    setPreviewVisible(false);
    if (restoreFocus) cartLink.focus();
  }

  const scheduleCartClose = () => {
    window.clearTimeout(cartCloseTimer);
    cartCloseTimer = window.setTimeout(() => {
      if (!cartLink.matches(':hover') && !cartPanel.matches(':hover') && !cartPanel.contains(document.activeElement)) {
        closeCartPreview();
      }
    }, 240);
  };

  const openCartPreview = async () => {
    closeAccount(true);
    window.clearTimeout(cartCloseTimer);
    const request = ++cartRequest;

    setPreviewVisible(true);
    cartProduct.replaceChildren();
    const loading = document.createElement('p');
    loading.className = 'mediazone-cart-preview__empty';
    loading.textContent = 'Chargement du panier\u2026';
    cartProduct.append(loading);

    try {
      const cartPath = `${new URL(cartLink.href).pathname.replace(/\/$/, '')}.js`;
      const response = await fetch(cartPath, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Cart request failed');
      const cart = await response.json();
      if (request === cartRequest) renderCart(cart);
    } catch (error) {
      if (request !== cartRequest) return;
      cartProduct.replaceChildren();
      const fallback = document.createElement('p');
      fallback.className = 'mediazone-cart-preview__empty';
      fallback.textContent = 'Le panier est accessible via le bouton ci-dessous.';
      cartProduct.append(fallback);
    }
  };

  if (nativeRenderContents) {
    cartElement.renderContents = (state) => {
      closeCartPreview();
      return nativeRenderContents(state);
    };
  }

  cartLink.addEventListener('pointerenter', () => {
    if (window.matchMedia(DESKTOP_HOVER).matches) openCartPreview();
  });

  cartLink.addEventListener('pointerleave', () => {
    if (window.matchMedia(DESKTOP_HOVER).matches) scheduleCartClose();
  });

  cartLink.addEventListener('focus', () => {
    if (window.matchMedia(DESKTOP_HOVER).matches) openCartPreview();
  });
  cartLink.addEventListener('blur', scheduleCartClose);

  cartLink.addEventListener('click', (event) => {
    if (!window.matchMedia(TOUCH_LAYOUT).matches) return;
    event.preventDefault();
    if (cartPanel.classList.contains('mediazone-cart-preview')) closeCartPreview();
    else openCartPreview();
  });

  cartPanel.addEventListener('pointerenter', () => window.clearTimeout(cartCloseTimer));
  cartPanel.addEventListener('pointerleave', scheduleCartClose);
  cartPanel.addEventListener('focusin', () => window.clearTimeout(cartCloseTimer));
  cartPanel.addEventListener('focusout', scheduleCartClose);
  cartPanel.querySelector('.cart-notification__close')?.addEventListener('click', () => closeCartPreview());

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && cartPanel.classList.contains('mediazone-cart-preview')) {
      event.preventDefault();
      closeCartPreview({ restoreFocus: true });
    }
  });

  document.addEventListener('pointerdown', (event) => {
    if (!cartPanel.classList.contains('mediazone-cart-preview')) return;
    if (!cartPanel.contains(event.target) && !cartLink.contains(event.target)) closeCartPreview();
  });
})();
